// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".add-to-cart[data-v-01167ffc]{height:43px}.add-button[data-v-01167ffc]{border:2px solid #e9e9e9;border-radius:10px;box-shadow:0 4px 4px 0 rgba(0,0,0,.1)!important}.border-right[data-v-01167ffc]{border-color:#b7b7b7}.border-left[data-v-01167ffc]{border-left:1px solid #b7b7b7}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
